module.exports = __webpack_public_path__ + "img/cleaf_banner_about.91894b92.jpg";